import React from 'react';
import { useSelector } from 'react-redux';

import {
    selectMultiplesCartList,
} from '~Betslip/selectors/userMultiplesSelectors';

import {
    selectHasMultiplesExceedBalance,
} from '~Betslip/selectors/userSelectors';

import MultiplesListItem from './MultiplesListItem';

const MultiplesList = () => {
    const userMultiples = useSelector(selectMultiplesCartList);
    const { isDepositNeeded } = useSelector(selectHasMultiplesExceedBalance);

    if (!userMultiples) {
        return null;
    }

    const renderUserMultiples = userMultiples.map((userMultiple) => (
        <MultiplesListItem
            key={userMultiple.id}
            id={userMultiple.id}
            depositRequired={isDepositNeeded}
        />
    ));

    return (
        <>
            {renderUserMultiples}
        </>
    );
};

export default MultiplesList;
